
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSatelliteMedium as ObiSatelliteMediumElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-satellite-medium.js';
 
 
 

 
 export const ObiSatelliteMedium = createComponent({
   react: React,
   tagName: 'obi-satellite-medium',
   elementClass: ObiSatelliteMediumElement,
   events: {
     
   }
  });
 
 